export function mktPhoneMask(value) {
	if (!value) {
		return [/\d/, ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
	}
	const numbers = value.replace(/\D/g, '').toString();
	if (numbers.length === 8) {
		return [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
	}
	return [/\d/, ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
}
